export var Layout;
(function (Layout) {
    Layout["Row"] = "row";
    Layout["Column"] = "column";
})(Layout || (Layout = {}));
export var AlignValue;
(function (AlignValue) {
    AlignValue["Center"] = "center";
    AlignValue["Left"] = "left";
    AlignValue["Right"] = "right";
    AlignValue["Top"] = "top";
    AlignValue["Bottom"] = "bottom";
})(AlignValue || (AlignValue = {}));
/**
 * @description
 * Caution: Numbers are passed as string types in the message template builder.
 * Use `==` comparison instead of `===` comparison when using a regular enum instead of a string enum.
 */
export var FlexSizeSpecValue;
(function (FlexSizeSpecValue) {
    FlexSizeSpecValue[FlexSizeSpecValue["FillParent"] = 0] = "FillParent";
    FlexSizeSpecValue[FlexSizeSpecValue["WrapContent"] = 1] = "WrapContent";
})(FlexSizeSpecValue || (FlexSizeSpecValue = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight["Normal"] = "normal";
    FontWeight["Bold"] = "bold";
})(FontWeight || (FontWeight = {}));
export var MediaContentMode;
(function (MediaContentMode) {
    MediaContentMode["AspectFit"] = "aspectFit";
    MediaContentMode["AspectFill"] = "aspectFill";
    MediaContentMode["ScalesToFill"] = "scalesToFill";
})(MediaContentMode || (MediaContentMode = {}));
